'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _fabfitfunSharedUtils = require('@bit/fabfitfun.shared.utils.arg-types');

var _fabfitfunSharedUtils2 = _interopRequireDefault(_fabfitfunSharedUtils);

var _ShippingAddress = require('./ShippingAddress/ShippingAddress');

var _ShippingAddress2 = _interopRequireDefault(_ShippingAddress);

var _BoxStatus = require('./BoxStatus/BoxStatus');

var _BoxStatus2 = _interopRequireDefault(_BoxStatus);

var _UpgradeMembership = require('./UpgradeMembership/UpgradeMembership');

var _UpgradeMembership2 = _interopRequireDefault(_UpgradeMembership);

var _ReferAFriend = require('./ReferAFriend/ReferAFriend');

var _ReferAFriend2 = _interopRequireDefault(_ReferAFriend);

var _Box = require('./Box/Box');

var _Box2 = _interopRequireDefault(_Box);

require('./assets/fa-light.min.css');

require('./assets/fontawesome.min.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {
  var getIsAnnual = function getIsAnnual(subscriptions) {
    if (!subscriptions.live.length) {
      return false;
    }
    var annualSubscription = (0, _find2.default)(subscriptions.live, function (sub) {
      return sub.planCode == 'fffvipa';
    });

    return annualSubscription;
  };

  var boxStatuses = props.boxStatuses,
      boxStatusTitle = props.boxStatusTitle,
      boxStatusCTA = props.boxStatusCTA,
      referCTA = props.referCTA,
      referDescription = props.referDescription,
      referTitle = props.referTitle,
      shippingTitle = props.shippingTitle,
      sysdata = props.sysdata,
      upgradeCTA = props.upgradeCTA,
      upgradeDescription = props.upgradeDescription,
      upgradeTitle = props.upgradeTitle;
  var boxData = sysdata.boxData,
      userData = sysdata.userData;

  var isSelect = userData ? userData.select : false;
  var isAnnual = userData ? getIsAnnual(userData.subscriptions) : false;

  return _react2.default.createElement(
    'div',
    { className: 'd-flex fb-100 flex-jsb pad-32' },
    _react2.default.createElement(_Box2.default, { data: boxData }),
    userData && _react2.default.createElement(_ShippingAddress2.default, { title: shippingTitle, userData: userData }),
    _react2.default.createElement(_BoxStatus2.default, {
      cta: boxStatusCTA,
      title: boxStatusTitle,
      boxData: boxData,
      boxStatuses: boxStatuses
    }),
    !isSelect && _react2.default.createElement(_UpgradeMembership2.default, {
      title: upgradeTitle,
      desc: upgradeDescription,
      cta: upgradeCTA
    }),
    isSelect && _react2.default.createElement(_ReferAFriend2.default, {
      title: referTitle,
      desc: referDescription,
      cta: referCTA
    })
  );
};

exports.default = Header;


Header.propTypes = {
  sysdata: _propTypes2.default.shape({})
};

Header.defaultProps = {
  sysdata: {
    boxData: {
      season: {},
      currentBox: {},
      boxItems: {},
      boxAddons: {},
      shiplist: []
    }
  },
  boxStatuses: {
    BOX_STATUS_PROCESSING: 'Order Saved!',
    BOX_STATUS_ASSIGNED: 'Getting Ready to Ship',
    BOX_STATUS_SHIPPED: 'Your Box hs Shipped!',
    BOX_STATUS_DELIVERED: 'Your Box Has Arrived!',
    BOX_STATUS_PROBABLY_DELIVERED: 'Your Box hs Shipped!',
    BOX_STATUS_LAST_SEASON: 'Your Box has Arrived!',
    BOX_STATUS_NO_BOX: 'Your order has not yet been processed.'
  },
  shippingTitle: 'Shipping Address',
  boxStatusTitle: 'Box Status',
  boxStatusCTA: 'View Billing / Shipping Schedule',
  upgradeTitle: 'Upgrade to Select for Perks',
  upgradeDescription: 'Faster shipping, earlier access to add-ons, and customizations!',
  upgradeCTA: 'upgrade now',
  referCTA: 'refer now',
  referTitle: 'Refer Friends & Earn',
  referDescription: 'Earn $15 in credit for every friend that signs up.'
};

Header.args = [{
  title: 'Shipping Heading',
  key: 'shippingTitle',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status Heading',
  key: 'boxStatusTitle',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status CTA Text',
  key: 'boxStatusCTA',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Refer Heading',
  key: 'referTitle',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Refer Description',
  key: 'referDescription',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Refer CTA Text',
  key: 'referCTA',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Upgrade CTA Text',
  key: 'upgradeCTA',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Upgrade Heading',
  key: 'upgradeTitle',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Upgrade Description',
  key: 'upgradeDescription',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status Processing',
  key: 'boxStatuses.BOX_STATUS_PROCESSING',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status Assigned',
  key: 'boxStatuses.BOX_STATUS_ASSIGNED',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status Shipped',
  key: 'boxStatuses.BOX_STATUS_SHIPPED',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status Delivered',
  key: 'boxStatuses.BOX_STATUS_DELIVERED',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status Probably Delivered',
  key: 'boxStatuses.BOX_STATUS_PROBABLY_DELIVERED',
  type: _fabfitfunSharedUtils2.default.STRING
}, {
  title: 'Box Status No Box',
  key: 'boxStatuses.BOX_STATUS_NO_BOX',
  type: _fabfitfunSharedUtils2.default.STRING
}];

//# sourceMappingURL=Header.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/node_modules/@bit/fabfitfun.my-box.global.my-box-header/dist/Header.js
// module id = 511
// module chunks = 0